import { render, staticRenderFns } from "./ProductsDetails.vue?vue&type=template&id=111619b6&scoped=true"
import script from "./ProductsDetails.vue?vue&type=script&lang=js"
export * from "./ProductsDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductsDetails.vue?vue&type=style&index=0&id=111619b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111619b6",
  null
  
)

export default component.exports